import React from 'react';
import { STATUS_META, FINISHED_META, type EventListStatus } from './eventForm';

/** SAM-714 — Draft (amber) / Published (green) / Archived (grey); SAM-1249 — Finished (grey). */
export const EventStatusBadge: React.FC<{ status: EventListStatus }> = ({ status }) => {
  const m = status === 'finished' ? FINISHED_META : STATUS_META[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[12px] font-semibold whitespace-nowrap"
      style={{ padding: '2px 10px', borderRadius: 999, background: m.bg, color: m.fg }}
    >
      <span aria-hidden style={{ width: 6, height: 6, borderRadius: '50%', background: m.dot }} />
      {m.label}
    </span>
  );
};
